"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_apollo_1 = require("react-apollo");
var react_hook_form_1 = require("react-hook-form");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var CreateProgram = require("../../core/gql/mutations/create-program");
var UpdateProgram = require("../../core/gql/mutations/update-program");
var QueryProgram = require("../../core/gql/queries/program");
var QueryPrograms = require("../../core/gql/queries/programs");
var ShowOrganization = require("../../core/gql/queries/show-organizations");
var QueryTags = require("../../core/gql/queries/tags");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var apollo_helpers_1 = require("../../core/apollo-helpers");
var form_element_hook_1 = require("../../components/form/form-element-hook");
var tag_1 = require("../../models/tag");
var select_division_attributes_1 = require("../../components/program/select-division-attributes");
var CreateElement = form_element_hook_1.default;
var updateValuesForDivisionAttributes = function (values) {
    ["ageDivisions", "competitionGenders", "competitionLevels"].forEach(function (attributeName) {
        if (values[attributeName]) {
            values[attributeName] =
                Object.values(values[attributeName])
                    .filter(function (v) { return v; })
                    .map(function (id) { return parseInt(id); });
        }
    });
    return values;
};
var ProgramEditForm = function (_a) {
    var _b, _c, _d;
    var programId = _a.programId, organizationId = _a.organizationId;
    var history = react_router_dom_1.useHistory();
    var mutationOptions = {
        refetchQueries: programId ? [{ query: QueryProgram.QUERY, variables: { programId: programId } }] :
            [{ query: QueryPrograms.QUERY, variables: { organizationId: organizationId } }]
    };
    var _e = react_apollo_1.useMutation(CreateProgram.MUTATION, mutationOptions), createProgram = _e[0], createProgramResponse = _e[1];
    var _f = react_apollo_1.useMutation(UpdateProgram.MUTATION, mutationOptions), updateProgram = _f[0], updateProgramResponse = _f[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var programEditForm = react_hook_form_1.useForm();
    var setupFormDefaults = React.useCallback(function (queryProgramData, queryOrgData, queryTagData) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var possibleAreasOfOperation = tag_1.unarchivedOrgTagsForType(queryTagData === null || queryTagData === void 0 ? void 0 : queryTagData.tags, tag_1.TagType.AREA_OF_OPERATION);
        var existingCompGenders = ((_a = queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram) === null || _a === void 0 ? void 0 : _a.competitionGenders) || [];
        var existingAgeDivisions = ((_b = queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram) === null || _b === void 0 ? void 0 : _b.ageDivisions) || [];
        var existingCompLevels = ((_c = queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram) === null || _c === void 0 ? void 0 : _c.competitionLevels) || [];
        var areaOfOperation = ((_e = (_d = queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram) === null || _d === void 0 ? void 0 : _d.areaOfOperation) === null || _e === void 0 ? void 0 : _e.id) || (possibleAreasOfOperation.length == 1 ? possibleAreasOfOperation[0].id : "");
        Object.entries(Object.assign.apply(Object, __spreadArray(__spreadArray(__spreadArray([{
                name: queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram.name,
                description: queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram.description,
                ageDemographic: queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram.ageDemographic,
                isCoed: (_f = queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram) === null || _f === void 0 ? void 0 : _f.isCoed,
                sport: ((_g = queryProgramData === null || queryProgramData === void 0 ? void 0 : queryProgramData.showProgram) === null || _g === void 0 ? void 0 : _g.sportId) || ((_h = queryOrgData === null || queryOrgData === void 0 ? void 0 : queryOrgData.showOrganization) === null || _h === void 0 ? void 0 : _h.sport),
                areaOfOperation: areaOfOperation
            }], existingCompGenders.map(function (tag) {
            var _a;
            return _a = {}, _a[select_division_attributes_1.buildCheckboxName(tag, "competitionGenders")] = true, _a;
        })), existingAgeDivisions.map(function (tag) {
            var _a;
            return _a = {}, _a[select_division_attributes_1.buildCheckboxName(tag, "ageDivisions")] = true, _a;
        })), existingCompLevels.map(function (tag) {
            var _a;
            return _a = {}, _a[select_division_attributes_1.buildCheckboxName(tag, "competitionLevels")] = true, _a;
        })))).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            programEditForm.setValue(key, value);
        });
    }, []);
    var queryOrganization = react_apollo_1.useQuery(ShowOrganization.QUERY, { variables: { organizationId: organizationId } });
    var queryProgram = react_apollo_1.useQuery(QueryProgram.QUERY, {
        variables: { programId: programId },
        skip: !programId,
    });
    var loadOrgTagsResponse = react_apollo_1.useQuery(QueryTags.QUERY, {
        variables: { organizationId: organizationId },
    });
    var isSubmitting = createProgramResponse.loading || updateProgramResponse.loading;
    var register = programEditForm.register, handleSubmit = programEditForm.handleSubmit;
    React.useEffect(function () {
        setupFormDefaults(queryProgram.data, queryOrganization.data, loadOrgTagsResponse.data);
    }, [
        queryProgram.called, queryProgram.loading,
        loadOrgTagsResponse.called, loadOrgTagsResponse.loading,
        queryOrganization.called, queryOrganization.loading
    ]);
    var submit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var isCreate, variables, feedbackMessage, resp, resp, e_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateValuesForDivisionAttributes(values);
                    isCreate = !programId;
                    variables = __assign(__assign({}, values), { organizationId: organizationId, sportId: values.sport, areaOfOperation: values.areaOfOperation ? parseInt(values.areaOfOperation) : null });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!isCreate) return [3 /*break*/, 3];
                    return [4 /*yield*/, createProgram({ variables: variables })];
                case 2:
                    resp = _a.sent();
                    if (resp.data && resp.data.createProgram) {
                        feedbackMessage = "The program " + resp.data.createProgram.name + " has been created.";
                    }
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, updateProgram({ variables: __assign(__assign({}, variables), { id: programId }) })];
                case 4:
                    resp = _a.sent();
                    feedbackMessage = "The program " + resp.data.updateProgram.name + " has been updated.";
                    _a.label = 5;
                case 5:
                    setFeedbackMessage({
                        variables: {
                            message: feedbackMessage,
                            isError: false,
                            autoclose: true,
                        },
                    });
                    hide(true);
                    return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    errorMessage = isCreate
                        ? "Program create failed. Please try again."
                        : "Program update failed. Please try again.";
                    setFeedbackMessage({
                        variables: {
                            message: errorMessage,
                            isError: true,
                            autoclose: true,
                        },
                    });
                    console.warn("Failed to properly validate and submit program and season forms.");
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var hide = function (updated) {
        history.push("/organizations/" + organizationId + "/programs");
    };
    // UTILS
    var getAgeDemographicOptions = function () {
        return [
            { text: "Youth", value: "YOUTH" },
            { text: "Adult", value: "ADULT" },
        ];
    };
    var getAreaOfOperationOptions = function () {
        var _a, _b, _c;
        var options = tag_1.unarchivedOrgTagsForType((_a = loadOrgTagsResponse.data) === null || _a === void 0 ? void 0 : _a.tags, tag_1.TagType.AREA_OF_OPERATION)
            .map(function (area) {
            return { text: area.name, value: "" + area.id };
        });
        options = __spreadArray([{ text: "Select an area of operation", value: "" }], options);
        var selectedArea = (_c = (_b = queryProgram === null || queryProgram === void 0 ? void 0 : queryProgram.data) === null || _b === void 0 ? void 0 : _b.showProgram) === null || _c === void 0 ? void 0 : _c.areaOfOperation;
        if ((selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.id) && !options.find(function (option) { return option.value == (selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.id); })) {
            options = __spreadArray(__spreadArray([], options), [{ text: selectedArea.name + " (Archived)", value: "" + selectedArea.id }]);
        }
        return options;
    };
    var headerText = programId ? "Edit Program" : "New Program";
    var possibleAgeDivision = tag_1.unarchivedOrgTagsForType((_b = loadOrgTagsResponse.data) === null || _b === void 0 ? void 0 : _b.tags, tag_1.TagType.AGE_DIVISION);
    var possibleCompetitionGenders = tag_1.unarchivedOrgTagsForType((_c = loadOrgTagsResponse.data) === null || _c === void 0 ? void 0 : _c.tags, tag_1.TagType.COMPETITION_GENDER);
    var possibleCompetitionLevels = tag_1.unarchivedOrgTagsForType((_d = loadOrgTagsResponse.data) === null || _d === void 0 ? void 0 : _d.tags, tag_1.TagType.COMPETITION_LEVEL);
    var readyToShow = apollo_helpers_1.isQueryFinished(queryProgram) && apollo_helpers_1.isQueryFinished(loadOrgTagsResponse);
    // RENDERING
    return (React.createElement("div", { className: "u-maxWidthSm" }, readyToShow && (React.createElement("div", { id: "program-create-editor-content", className: "page-content u-xs-padRightMd u-xs-padLeftMd" },
        React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
            React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                React.createElement("h2", null, headerText))),
        React.createElement("form", { onSubmit: handleSubmit(submit) },
            React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                React.createElement(CreateElement, { label: "Name", useHookResponse: programEditForm, inputRef: register({
                        required: "You must enter a name for the program.",
                    }), field: "name", type: "text", placeholder: "Program name" })),
            React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                React.createElement(CreateElement, { label: "Description", useHookResponse: programEditForm, inputRef: register({
                        required: false,
                    }), field: "description", type: "text", placeholder: "Program description" })),
            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { label: "Sport", useHookResponse: programEditForm, inputRef: register({
                            required: "You must select a sport",
                        }), field: "sport", type: "sport" })),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { label: "Area of Operation", useHookResponse: programEditForm, inputRef: register({
                            required: "You must select an area of operation",
                        }), field: "areaOfOperation", type: "select", options: getAreaOfOperationOptions() }))),
            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12 u-padTopLg" },
                    React.createElement(CreateElement, { useHookResponse: programEditForm, field: "isCoed", inputRef: register({
                            required: false,
                        }), type: "checkbox", label: "Track These As Coed Teams", isInline: true })),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                    React.createElement(CreateElement, { className: "u-hidden", labelHidden: true, label: "Age Demographic", useHookResponse: programEditForm, field: "ageDemographic", inputRef: register({
                            required: false,
                        }), type: "select", options: getAgeDemographicOptions() }))),
            React.createElement(select_division_attributes_1.default, { attributeTags: possibleCompetitionGenders, title: "Gender Groups", attributeName: "competitionGenders", seasonForm: programEditForm }),
            React.createElement(select_division_attributes_1.default, { attributeTags: possibleAgeDivision, title: "Age Divisions", attributeName: "ageDivisions", seasonForm: programEditForm }),
            React.createElement(select_division_attributes_1.default, { attributeTags: possibleCompetitionLevels, title: "Competition Levels", attributeName: "competitionLevels", seasonForm: programEditForm }),
            React.createElement(teamsnap_ui_1.Cell, { mods: "u-textLeft u-padTopMd u-padBottomXl u-spaceBottomXl" },
                React.createElement("div", { className: "button-list" },
                    React.createElement(teamsnap_ui_1.Button, { mods: "Button--negative", icon: "dismiss", onClick: hide }, "Cancel"),
                    React.createElement(teamsnap_ui_1.Button, { isDisabled: isSubmitting, type: "submit", color: "primary", icon: isSubmitting ? null : "check" },
                        isSubmitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: "13px", height: "13px" } }),
                        programId ? "Update" : "Create",
                        " Program"))))))));
};
exports.default = ProgramEditForm;
//# sourceMappingURL=program-edit-form.js.map